import { render } from "./EditorImage.vue?vue&type=template&id=79536c50&scoped=true"
import script from "./EditorImage.vue?vue&type=script&lang=ts"
export * from "./EditorImage.vue?vue&type=script&lang=ts"

import "./EditorImage.vue?vue&type=style&index=0&id=79536c50&lang=scss"
import "./EditorImage.vue?vue&type=style&index=1&id=79536c50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79536c50"

export default script